import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { fetchVenues, fetchVenue, updateVenue, type UpdateVenueInput } from '@/services/api/venues'
import { dataKeys } from './useDashboardData'

export const venueKeys = {
  all: ['venues'] as const,
  lists: () => [...venueKeys.all, 'list'] as const,
  list: () => [...venueKeys.lists()] as const,
  details: () => [...venueKeys.all, 'detail'] as const,
  detail: (id: number) => [...venueKeys.details(), id] as const,
}

export function useVenues() {
  return useQuery({
    queryKey: venueKeys.list(),
    queryFn: fetchVenues,
  })
}

export function useVenue(id: number) {
  return useQuery({
    queryKey: venueKeys.detail(id),
    queryFn: () => fetchVenue(id),
    enabled: id > 0,
  })
}

export function useUpdateVenue() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, input }: { id: number; input: UpdateVenueInput }) => updateVenue(id, input),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: venueKeys.detail(variables.id) })
      queryClient.invalidateQueries({ queryKey: venueKeys.lists() })
      queryClient.invalidateQueries({ queryKey: dataKeys.dashboard() })
    },
  })
}
